<!------------ START TEMPLATE ------------>
<template>
  <div>
    <!------------ START FORM ------------>
    <form role="form" @submit.stop.prevent="onSubmit">
      <!-----============================ OBS: No status deve ter um campo SELECT que irá trazer as opções criadas pelo usuário na parte cadastro de Status do Menu USUARIO  ==================------->
      <div class="vx-row">
        <div class="vx-col mb-6">
          <span>Ativo</span>
          <vs-switch
            color="success"
            v-model="formCadastro.status"
            style="width: 60px"
          >
            <span slot="on">Ativo</span>
            <span slot="off">Inativo</span>
          </vs-switch>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Nome Fantasia</span>
          <vs-input
            size="large"
            class="w-full"
            name="Nome Fantasia"
            id="Nome Fantasia"
            v-model="formCadastro.nome"
            v-validate="{ required: true, min: 6, no_semicolon: true }"
            :state="validateState(veeFields, veeErrors, 'Nome Fantasia')"
            :class="validateStateClass(veeFields, veeErrors, 'Nome Fantasia')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Razão Social</span>
          <vs-input
            size="large"
            class="w-full"
            name="Razão Social"
            id="Razão Social"
            v-model="formCadastro.razaoSocial"
            v-validate="{ required: true, min: 6, no_semicolon: true }"
            :state="validateState(veeFields, veeErrors, 'Razão Social')"
            :class="validateStateClass(veeFields, veeErrors, 'Razão Social')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>CNPJ/CPF</span>
          <vs-input
            size="large"
            class="w-full"
            name="CNPJ"
            id="CNPJ"
            v-model="formCadastro.cnpj"
            v-validate="{ required: true, min: escolherCPFCNPJMin }"
            :state="validateState(veeFields, veeErrors, 'CNPJ')"
            :class="validateStateClass(veeFields, veeErrors, 'CNPJ')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
            v-mask="[DOCUMENT_MASK.CPF_WITH_CNPJ, DOCUMENT_MASK.CNPJ]"
            @input="formCadastro.cnpj = $event.toUpperCase()"
            icon-pack="feather"
            icon="icon-user-check"
            icon-no-border
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>N° Registro SUSEP</span>
          <vs-input
            size="large"
            class="w-full"
            name="N° Registro SUSEP"
            id="N° Registro SUSEP"
            v-mask="'#########'"
            v-model="formCadastro.susep"
            v-validate="{ required: true, min: 9 }"
            :state="validateState(veeFields, veeErrors, 'N° Registro SUSEP')"
            :class="
              validateStateClass(veeFields, veeErrors, 'N° Registro SUSEP')
            "
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
            icon-pack="feather"
            icon="icon-user"
            icon-no-border
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Celular do Responsável</span>
          <vs-input
            size="large"
            class="w-full"
            name="Celular"
            id="Celular"
            v-model="formCadastro.celularResponsavel"
            v-validate="{ required: true }"
            :state="validateState(veeFields, veeErrors, 'Celular')"
            :class="validateStateClass(veeFields, veeErrors, 'Celular')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
            v-mask="'(##) #####-####'"
            icon-pack="feather"
            icon="icon-smartphone"
            icon-no-border
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Email do Responsável</span>
          <vs-input
            type="email"
            size="large"
            class="w-full"
            name="Email"
            id="Email"
            v-model="formCadastro.emailResponsavel"
            v-validate="{ required: true, email: true }"
            :state="validateState(veeFields, veeErrors, 'Email')"
            :class="validateStateClass(veeFields, veeErrors, 'Email')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
            icon-pack="feather"
            icon="icon-mail"
            icon-no-border
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>ISS</span>
          <vs-input
            size="large"
            class="w-full"
            name="ISS"
            id="ISS"
            type="number"
            step="0.0001"
            v-model="formCadastro.iss"
            :state="validateState(veeFields, veeErrors, 'ISS')"
            :class="validateStateClass(veeFields, veeErrors, 'ISS')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
            icon-pack="feather"
            icon="icon-user"
            icon-no-border
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>CEP</span>
          <vs-input
            size="large"
            class="w-full"
            name="Cep"
            id="Cep"
            @keyup.native="keymonitor"
            v-model="formCadastro.cep"
            v-validate="{ required: true, min: 10 }"
            :state="validateState(veeFields, veeErrors, 'Cep')"
            :class="validateStateClass(veeFields, veeErrors, 'Cep')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
            v-mask="'##.###-###'"
            icon-pack="feather"
            icon="icon-home"
            icon-no-border
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Endereço</span>
          <vs-input
            size="large"
            class="w-full"
            name="Endereço"
            id="Endereço"
            v-model="formCadastro.endereco"
            v-validate="{ required: true, min: 6 }"
            :state="validateState(veeFields, veeErrors, 'Endereço')"
            :class="validateStateClass(veeFields, veeErrors, 'Endereço')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
            icon-pack="feather"
            icon="icon-map-pin"
            icon-no-border
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Número</span>
          <vs-input
            size="large"
            class="w-full"
            name="Numero"
            id="Numero"
            v-model="formCadastro.numero"
            v-validate="{ required: true }"
            :state="validateState(veeFields, veeErrors, 'Numero')"
            :class="validateStateClass(veeFields, veeErrors, 'Numero')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
            icon-pack="feather"
            icon="icon-check-circle"
            icon-no-border
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Complemento</span>
          <vs-input
            size="large"
            class="w-full"
            name="Complemento"
            id="Complemento"
            v-model="formCadastro.complemento"
            :state="validateState(veeFields, veeErrors, 'Complemento')"
            :class="validateStateClass(veeFields, veeErrors, 'Complemento')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
            icon-pack="feather"
            icon="icon-check-circle"
            icon-no-border
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Bairro</span>
          <vs-input
            size="large"
            class="w-full"
            name="Bairro"
            id="Bairro"
            v-model="formCadastro.bairro"
            v-validate="{ required: true }"
            :state="validateState(veeFields, veeErrors, 'Bairro')"
            :class="validateStateClass(veeFields, veeErrors, 'Bairro')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
            icon-pack="feather"
            icon="icon-map-pin"
            icon-no-border
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Cidade</span>
          <vs-input
            size="large"
            class="w-full"
            name="Cidade"
            id="Cidade"
            v-model="formCadastro.cidade"
            v-validate="{ required: true }"
            :state="validateState(veeFields, veeErrors, 'Cidade')"
            :class="validateStateClass(veeFields, veeErrors, 'Cidade')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
            icon-pack="feather"
            icon="icon-map"
            icon-no-border
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Estado</span>
          <vs-input
            size="large"
            class="w-full"
            name="Estado"
            id="Estado"
            v-model="formCadastro.estado"
            v-validate="{ required: true, min: 2, max: 2 }"
            :state="validateState(veeFields, veeErrors, 'Estado')"
            :class="validateStateClass(veeFields, veeErrors, 'Estado')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
            icon-pack="feather"
            icon="icon-navigation"
            icon-no-border
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Banco</span>
          <v-select
            :options="listBancos"
            name="Banco"
            id="Banco"
            v-model="formCadastro.banco"
            :reduce="(item) => item.id"
            v-validate="{ required: true }"
            placeholder="Selecione"
            :state="validateState(veeFields, veeErrors, 'Banco')"
            :class="validateStateClass(veeFields, veeErrors, 'Banco')"
          ></v-select>
        </div>
      </div>

      <div class="vx-col w-full mb-6">
        <label>Agência</label>
        <vs-input
          size="large"
          class="w-full"
          name="Agencia"
          id="Agencia"
          type="number"
          v-model="formCadastro.agencia"
          v-validate="'required|numeric|min_value:0'"
          :state="validateState(veeFields, veeErrors, 'Agencia')"
          :class="validateStateClass(veeFields, veeErrors, 'Agencia')"
          val-icon-danger="clear"
          danger-text="Preencha este Campo"
          icon-pack="feather"
          icon="icon-dollar-sign"
          icon-no-border
        />
      </div>

      <div class="vx-col w-full mb-6">
        <label>Conta</label>
        <vs-input
          size="large"
          class="w-full"
          name="Conta"
          id="Conta"
          type="number"
          v-model="formCadastro.conta"
          v-validate="'required|numeric|min_value:0'"
          :state="validateState(veeFields, veeErrors, 'Conta')"
          :class="validateStateClass(veeFields, veeErrors, 'Conta')"
          val-icon-danger="clear"
          danger-text="Preencha este Campo"
          icon-pack="feather"
          icon="icon-dollar-sign"
          icon-no-border
        />
      </div>

      <div class="vx-col w-full mb-6">
        <label>Dígito verificador da conta</label>
        <vs-input
          size="large"
          class="w-full"
          name="Dígito verificador da conta"
          id="Dígito verificador da conta"
          type="number"
          v-model="formCadastro.digito"
          v-validate="'required|numeric|min_value:0'"
          :state="
            validateState(veeFields, veeErrors, 'Dígito verificador da conta')
          "
          :class="
            validateStateClass(
              veeFields,
              veeErrors,
              'Dígito verificador da conta',
            )
          "
          val-icon-danger="clear"
          danger-text="Preencha este Campo"
          icon-pack="feather"
          icon="icon-dollar-sign"
          icon-no-border
        />
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Chave Pix</span>
          <vs-input
            size="large"
            class="w-full"
            name="ChavePix"
            id="ChavePix"
            v-model="formCadastro.chavePix"
            :state="validateState(veeFields, veeErrors, 'ChavePix')"
            :class="validateStateClass(veeFields, veeErrors, 'ChavePix')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
            icon-pack="feather"
            icon="icon-navigation"
            icon-no-border
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Logo</span>
          <DragAndDropFileInput
            texto="Arraste sua imagem aqui ou clique abaixo para fazer o upload"
            :extensoesPermitidas="'png-jpg-jpeg'"
            @files="handleFiles"
          />
        </div>
        <div
          class="vx-col flex flex-col gap-2 mt-4 w-full"
          style="position: relative"
        >
          <img v-if="image" class="imagem h-32" :src="image" />
          <vs-button
            v-if="image"
            class="button-overlay"
            color="danger"
            icon-pack="feather"
            icon="icon-trash"
            @click="removerImage"
            style="position: absolute; top: 10px; right: 10px; z-index: 1"
          >
          </vs-button>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Optante pelo simples nacional?</span>
          <v-select
            :options="opcoesSimNao"
            name="Optante pelo simples nacional"
            label="label"
            id="Optante pelo simples nacional"
            v-model="formCadastro.simples"
            v-validate="{ required: true }"
            class="select-large w-full"
            :reduce="(item) => item.id"
            :state="
              validateState(
                veeFields,
                veeErrors,
                'Optante pelo simples nacional',
              )
            "
            :class="
              validateStateClass(
                veeFields,
                veeErrors,
                'Optante pelo simples nacional',
              )
            "
          ></v-select>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Assessoria</span>
          <v-select
            :options="listDivisoes"
            name="Assessoria"
            label="label"
            id="Assessoria"
            v-model="formCadastro.idDivisao"
            :state="validateState(veeFields, veeErrors, 'Assessoria')"
            :class="validateStateClass(veeFields, veeErrors, 'Assessoria')"
            :reduce="(item) => item.id"
          ></v-select>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col mb-6">
          <span>Permitir assessoria fazer cotação pela corretora?</span>
          <vs-switch
            color="success"
            v-model="formCadastro.permitirCotacaoAssessoria"
            style="width: 60px"
          >
            <span slot="on">Sim</span>
            <span slot="off">Não</span>
          </vs-switch>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <span>Convênio</span>
          <v-select
            :options="listConvenio"
            name="Convênio"
            label="label"
            id="Convênio"
            v-model="formCadastro.idConvenio"
            class="select-large w-full"
            :reduce="(item) => item.id"
            :state="validateState(veeFields, veeErrors, 'Convênio')"
            :class="validateStateClass(veeFields, veeErrors, 'Convênio')"
            :disabled="formCadastro.idDivisao !== null"
          ></v-select>
        </div>
      </div>

      <ErrorsAlert :errors="errors" />

      <div class="vx-row">
        <div class="vx-col w-full text-right">
          <vs-button
            color="warning"
            type="border"
            class="mr-3 mb-2"
            @click.stop.prevent="onReset"
            >Cancelar
          </vs-button>
          <BotaoSubmit
            variant="success"
            :edit="this.dados.idRegional == null ? false : true"
            :aguarde="aguardeCadastro"
          ></BotaoSubmit>
        </div>
      </div>
    </form>
    <!------------ END FORM ------------>
  </div>
</template>
<!------------ END TEMPLATE ------------>

<!------------ START SCRIPT ------------>
<script>
import vSelect from 'vue-select';
import service from '../../services';
import BotaoSubmit from '../../components/BotaoSubmit';
import functions from '../../utils/functions';
import notify from '../../utils/notify';
import utilsList from '../../utils/list';
import ErrorsAlert from '../../components/ErrorsAlert';
import cpfCnpj from '../../services/cpfCnpj';
import DragAndDropFileInput from '../../components/file-upload/upload-dragdown.vue';
import { OPCOES_SIM_NAO } from '../../utils/constants';
import reportsApi from '@/services/reports.api';
import { Validator } from 'vee-validate';
import { DOCUMENT_MASK } from '../../constants/cpfCnpj';

export default {
  props: {
    sideBar: {
      type: Boolean,
    },
    dados: {
      type: Object,
    },
  },
  watch: {
    dados() {
      this.preencheForm();
    },
    'formCadastro.idDivisao': function (val) {
      if (val) {
        const divisao = this.listDivisoes.find((item) => item.id === val);
        this.formCadastro.idConvenio = divisao.covenantId;
      }
    },
  },
  computed: {
    errors() {
      return this.$validator.errors.all();
    },
    escolherCPFCNPJMin() {
      return this.formCadastro.cnpj && this.formCadastro.cnpj.length <= 14
        ? 14
        : 18;
    },
  },
  data() {
    return {
      DOCUMENT_MASK,
      validateState: utilsList.validateState,
      validateStateClass: utilsList.validateStateClass,
      aguardeCadastro: false,
      idEmpresa: null,
      opcoesSimNao: OPCOES_SIM_NAO,
      estados: [],
      cidades: [],
      integracoes: [],
      listBancos: [],
      listTiposEscritorios: [],
      corretoras: [],
      listDivisoes: [],
      listConvenio: [],
      estado: null,
      funcoesValicao: null,
      companyId: 118,
      image: null,
      formCadastro: {
        idRegional: null,
        idEmpresa: null,
        integracao: null,
        idCarteira: null,
        status: true,
        nome: '',
        razaoSocial: '',
        simples: null,
        cep: '',
        endereco: '',
        bairro: '',
        numero: '',
        complemento: '',
        cidade: '',
        estado: '',
        idTipoEscritorio: 1,
        cnpj: '',
        susep: '',
        iss: null,
        banco: null,
        agencia: null,
        conta: null,
        digito: null,
        chavePix: null,
        logo: null,
        permitirCotacaoAssessoria: false,
        idDivisao: null,
        idConvenio: null,
      },
    };
  },
  methods: {
    preencheForm() {
      if (this.dados.idRegional) {
        this.formCadastro.idRegional = this.dados.idRegional;
        this.formCadastro.idCarteira = this.dados.idCarteira;
        this.formCadastro.status = this.dados.deletedAt == null ? true : false;
        this.formCadastro.nome = this.dados.nome;
        this.formCadastro.razaoSocial = this.dados.razaoSocial;
        this.formCadastro.simples = this.dados.simples;
        // SEGURADORA
        this.formCadastro.cep = this.dados.cep;
        this.formCadastro.endereco = this.dados.endereco;
        this.formCadastro.bairro = this.dados.bairro;
        this.formCadastro.numero = this.dados.numero;
        this.formCadastro.complemento = this.dados.complemento;
        this.formCadastro.cidade = this.dados.cidade;
        this.formCadastro.estado = this.dados.estado;
        this.formCadastro.cnpj = this.dados.cnpj;
        this.formCadastro.susep = this.dados.susep;
        this.formCadastro.iss = this.dados.iss;
        this.formCadastro.banco = this.dados.banco;
        this.formCadastro.agencia = this.dados.agencia;
        this.formCadastro.conta = this.dados.conta;
        this.formCadastro.digito = this.dados.digito;
        this.formCadastro.celularResponsavel = this.dados.celularResponsavel;
        this.formCadastro.emailResponsavel = this.dados.emailResponsavel;
        this.formCadastro.chavePix = this.dados.chavePix;
        this.formCadastro.logo = this.dados.logo;
        this.image = this.dados.logo;
        this.formCadastro.permitirCotacaoAssessoria =
          this.dados.permitirCotacaoAssessoria;

        this.formCadastro.idCorretora = this.dados.idCorretora;
        this.corretoras = this.dados.corretoras;
        this.formCadastro.idDivisao = this.dados.idDivisao;
        this.formCadastro.idConvenio = this.dados.idConvenio;
      } else {
        this.resetForm();
      }
    },

    onSubmit() {
      if (!this.formCadastro.cnpj) {
        notify.notifyFail(this.$vs, 'CPF OU CNPJ Inválido');
        return;
      }

      const validado = cpfCnpj.valida_cpf_cnpj(this.formCadastro.cnpj);
      if (!validado) {
        notify.notifyFail(this.$vs, 'CPF OU CNPJ Inválido');
        return;
      }

      this.formCadastro.idEmpresa = this.idEmpresa;

      var action = 'Atualizar';
      var msgRetorno = 'Dados Atualizados com sucesso';
      if (!this.formCadastro.idRegional) {
        action = 'Adicionar';
        msgRetorno = 'Registro Adicionado com sucesso';
      }

      this.$validator.validateAll().then((result) => {
        if (result) {
          this.aguardeCadastro = true;
          service
            .post('Regional', action, this.formCadastro)
            .then(() => {
              this.aguardeCadastro = false;
              notify.notifySuccess(this.$vs, msgRetorno);
              this.$emit('concluido');
            })
            .catch((error) => {
              this.aguardeCadastro = false;
              notify.notifyFail(this.$vs, error);
            });
        }
      });
    },

    keymonitor: async function () {
      if (this.formCadastro.cep.length == 10) {
        this.$vs.loading();
        var cepbusca = this.formCadastro.cep.replace('.', '').replace('-', '');

        try {
          const { data } = await service.post('g', 'BuscaCEP', {
            cep: cepbusca,
          });

          this.$set(this.formCadastro, 'endereco', data.street);
          this.$set(this.formCadastro, 'bairro', data.neighborhood);
          this.$set(this.formCadastro, 'cidade', data.city);
          this.$set(this.formCadastro, 'estado', data.state);
        } catch (error) {
          this.$set(this.formCadastro, 'endereco', null);
          this.$set(this.formCadastro, 'bairro', null);
          this.$set(this.formCadastro, 'cidade', null);
          this.$set(this.formCadastro, 'estado', null);

          notify.notifyFail(this.$vs, 'Não Foi possível encontrar o cep');
        } finally {
          this.$vs.loading.close();
        }
      }
    },
    resetForm() {
      this.formCadastro = {
        idRegional: null,
        idEmpresa: null,
        integracao: null,
        idCarteira: null,
        status: true,
        nome: '',
        razaoSocial: '',
        simples: null,
        cep: '',
        endereco: '',
        bairro: '',
        numero: '',
        cidade: '',
        estado: '',
        idTipoEscritorio: 1,
        cnpj: '',
        susep: '',
        iss: null,
        banco: null,
        agencia: null,
        conta: null,
        digito: null,
        chavePix: null,
        logo: null,
        permitirCotacaoAssessoria: false,
        idDivisao: null,
        idConvenio: null,
      };
    },
    onReset(evt) {
      if (this.sideBar == true) {
        this.$emit('cancel');
      } else {
        evt.preventDefault();
        this.resetForm();
        this.$nextTick(() => {
          this.show = true;
        });
      }
    },

    async getDominios() {
      try {
        const Promises = [
          functions.buscaDadosSelects(
            'domBancos',
            this.listBancos,
            'LongName',
            'idBanco',
          ),
          functions.buscaDadosSelects(
            'domTipoEscritorio',
            this.listTiposEscritorios,
            'label',
            'idTipoEscritorio',
          ),
        ];

        await Promise.all(Promises);

        const [consultancies, covenants] = await Promise.all([
          reportsApi.getCompanyConsultancies(this.companyId),
          reportsApi.getCompanyCovenants(this.companyId),
        ]);
        this.listDivisoes = consultancies.map((item) => ({
          id: item.id,
          label: item.divisionName,
          covenantId: item.covenantId,
        }));
        this.listConvenio = covenants.map((item) => ({
          id: item.id,
          label: item.name,
        }));

        this.listBancos = this.listBancos.sort((a, b) => {
          const COMPE_A = a.label.split(' - ')[0];
          const COMPE_B = b.label.split(' - ')[0];

          return +COMPE_A - +COMPE_B;
        });
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      }
    },
    async handleFiles(files) {
      const render = new FileReader();
      render.onload = (e) => (this.image = e.target.result);
      render.readAsDataURL(files[0]);
      await this.uploadAWS(files[0]);
    },
    async uploadAWS(file) {
      const { id_usuario } = functions.getDecoded(localStorage);
      const url = `logo-corretora/${id_usuario}`;

      const formDataSend = new FormData();
      formDataSend.append('file', file, file.name);

      this.$vs.loading();
      try {
        const res = await service.upload('upload', url, formDataSend);

        this.formCadastro.logo = res;
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
    removerImage() {
      this.image = null;
      this.formCadastro.logo = null;
    },
  },
  created() {
    Validator.extend('no_semicolon', {
      getMessage: (field) => `No campo: ${field}, Não utilize ;`,
      validate: (value) => !value.includes(';'),
    });
  },
  mounted() {
    this.getDominios();
  },
  components: {
    BotaoSubmit,
    'v-select': vSelect,
    ErrorsAlert,
    DragAndDropFileInput,
  },
};
</script>
<!------------ END SCRIPT ------------>
